<template>
  <v-card flat class="py-3">
    <v-card-title class="pb-0 pt-0 text-body-1 font-weight-bold"
      >Seleziona una lista a cui aggiungere:</v-card-title
    >
    <v-card-text class="pb-0 pt-1">
      <span v-if="product" class="qty-to-add text-body-2">
        <i>{{ quantityToAdd }} {{ unitToAdd }}</i>
        di {{ product.name }}:
      </span>
      <v-list class="overflow-y-auto" style="max-height: 300px">
        <!-- LOADING STATE -->
        <template v-if="loading">
          <v-skeleton-loader
            type="list-item-three-line"
            class="mb-2"
            v-for="n in 2"
            :key="'loading-' + n"
          />

          <div class="text-center mt-2 mb-4 font-italic grey--text">
            Caricamento liste in corso...
          </div>
        </template>

        <!-- ACTUAL LIST -->
        <template v-else>
          <div v-for="list in whishlistLists" :key="list.id">
            <v-list-item @click="selectList(list.id)">
              <v-list-item-title>
                <v-badge
                  color="primary"
                  inline
                  :content="list.size"
                  :value="list.size > 0"
                >
                  {{ list.name }}
                </v-badge>
              </v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>
          </div>
        </template>
      </v-list>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-form class="d-flex" @submit.prevent="createAndSelect">
        <v-text-field
          label="Crea una nuova lista"
          hide-details="auto"
          v-model="listName"
          dense
          required
        ></v-text-field>
        <v-btn type="submit" small color="primary">CREA</v-btn>
      </v-form>
    </v-card-actions>
  </v-card>
</template>
<script>
import list from "~/mixins/list";
// import CartService from "~/service/cartService";

export default {
  name: "ListSelector",
  mixins: [list],
  props: {
    quantity: { type: Number, required: false },
    product: { type: Object, required: false }
  },
  data() {
    return {
      loading: true
    };
  },
  computed: {
    whishlistLists() {
      return this.lists;
    },
    quantityToAdd() {
      let multiplier = 1;
      if (
        (this.product.productInfos.TIPOLOGIA === "Sfuso" &&
          this.product.productInfos.WEIGHT_SELLING_SINGLE_UNIT) ||
        this.product.productInfos.TIPOLOGIA == "Confezione"
      ) {
        multiplier = Number(this.product.productInfos.WEIGHT_SELLING);
      }
      return multiplier != 1
        ? (this.quantity * multiplier).toFixed(2)
        : this.quantity * multiplier;
    },
    unitToAdd() {
      let unit = "PZ";
      if (this.product.productInfos.TIPOLOGIA === "Pezzo") {
        unit = "PZ";
      } else if (
        this.product.productInfos.TIPOLOGIA === "Sfuso" ||
        this.product.productInfos.TIPOLOGIA === "Confezione"
      ) {
        unit = this.product.productInfos.WEIGHT_UNIT_SELLING;
      }
      return unit;
    }
  },
  methods: {
    selectList(listId) {
      this.$emit("submit", { listId: listId });
    },
    async createAndSelect() {
      let list = await this.createList();
      this.$emit("submit", { listId: list.id });
    }
  },
  async created() {
    await this.reload();
  }
};
</script>
